import { CardActionArea, CardMedia, SelectChangeEvent } from '@mui/material'
import { Box } from '@mui/system'
import React, { useEffect, useState } from 'react'
import { textColors } from '../../../../Common/Color/Color'
import AddPhotoAlternateRoundedIcon from '@mui/icons-material/AddPhotoAlternateRounded'
import { Event } from '../../../../../redux/event/manageEvents/types'
import { useFetchImageUrl } from '../../../../../hooks/componentHooks/useFetchImageUrl'

interface EventUploadProps {
  handleChange: (
    eventOrValue:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | SelectChangeEvent<string>
      | Date
      | null
      | string,
    fieldName?: string,
  ) => void
  setImageFile: (file: File) => void
  eventDetails?: Event
  imageFile: File | undefined
}

const EventUpload: React.FC<EventUploadProps> = ({
  handleChange,
  setImageFile,
  eventDetails,
  imageFile,
}) => {
  const { imageUrl } = useFetchImageUrl(
    'images',
    (eventDetails && eventDetails.imageFilename) || '',
    'event',
    true,
  )
  const [imagePreview, setImagePreview] = useState<string | null>()

  useEffect(() => {
    if (imageFile) {
      setImagePreview(URL.createObjectURL(imageFile))
    } else {
      setImagePreview(imageUrl)
    }

    // Clean up object URL to avoid memory leaks
    return () => {
      if (imageFile) {
        URL.revokeObjectURL(imagePreview || '') // Revoke the object URL
      }
    }
  }, [imageUrl, imageFile])

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]
    if (file) {
      setImageFile(file)
      setImagePreview(URL.createObjectURL(file))
      handleChange(file.name, 'imageFilename') // Updating the form data with the file name
    }
  }

  return (
    <div>
      <Box position='relative' sx={{ height: '300px', overflow: 'hidden' }}>
        <CardActionArea
          component='label'
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            height: '100%',
          }}
        >
          <input
            id='event-image-input'
            hidden
            accept='image/*'
            type='file'
            onChange={handleFileChange}
          />
          {imagePreview ? (
            <CardMedia
              component='img'
              image={imagePreview}
              height='100%'
              alt='event-card-preview'
              sx={{ objectFit: 'cover', zIndex: 0 }}
            />
          ) : (
            <Box
              id='event-image-box'
              sx={{
                height: '100%',
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '2px dashed',
                borderColor: textColors.purpleTelus,
                color: textColors.purpleTelus,
                padding: 2, // Padding for better spacing
              }}
            >
              <AddPhotoAlternateRoundedIcon />
              Upload Image
            </Box>
          )}
        </CardActionArea>
      </Box>
    </div>
  )
}

export default EventUpload
